import { Box, Grid } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { Title } from "../../components/Desc";
import strings from "../../config/localization";
import BandobastReportsPanel from "./BandobastReportsPanel";
import { useParams } from "react-router-dom";
import ListExternalForces from "./external_forces/ListExternalForces";
import ListTimeslots from "../timeslots/ListTimeslots";
import ListCheckinStatus from "../checkin/ListCheckinStatus";
import ListLocations from "../locations/ListLocations";
import ListLiveLocations from "../live_locations/ListLiveLocations";
import AllocationSummary from "./allocation/AllocationSummary";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function BandobastHomePage() {
  const [value, setValue] = React.useState(0);
  const params = useParams();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ height: 400, width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Title text={strings.bandobast} />
          </Grid>
          <Grid item xs={12}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label={strings.timeslots}
                id="bandobast-timeslots"
                aria-controls="bandobast-timeslots"
              />
              <Tab
                label={strings.locations}
                id="bandobast-locations"
                aria-controls="bandobast-locations"
              />
              <Tab
                label={strings.allocations}
                id="bandobast-allocations"
                aria-controls="bandobast-allocations"
              />
              <Tab
                label={strings.externalForces}
                id="bandobast-external-forces"
                aria-controls="bandobast-external-forces"
              />
              <Tab
                label={strings.reports}
                id="bandobast-reports"
                aria-controls="bandobast-reports"
              />
            </Tabs>
          </Grid>
        </Grid>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ListTimeslots bandobastId={params.bandobastId} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ListLocations bandobastId={params.bandobastId} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AllocationSummary bandobastId={params.bandobastId} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ListExternalForces bandobastId={params.bandobastId} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <BandobastReportsPanel bandobastId={params.bandobastId} />
      </CustomTabPanel>
    </Box>
  );
}
